import { render, staticRenderFns } from "./SurveyManagement.vue?vue&type=template&id=79cdb252&scoped=true"
import script from "./SurveyManagement.vue?vue&type=script&lang=js"
export * from "./SurveyManagement.vue?vue&type=script&lang=js"
import style0 from "./SurveyManagement.vue?vue&type=style&index=0&id=79cdb252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cdb252",
  null
  
)

export default component.exports